import { render, staticRenderFns } from "./ProgressItem.vue?vue&type=template&id=f5de4dde&scoped=true"
import script from "./ProgressItem.vue?vue&type=script&lang=js"
export * from "./ProgressItem.vue?vue&type=script&lang=js"
import style0 from "./ProgressItem.vue?vue&type=style&index=0&id=f5de4dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5de4dde",
  null
  
)

export default component.exports